export default "__VITE_ASSET__OuuB0H_s__"